import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class ShapeService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	create(shape, callback) {
		const url = "/ecosystem/api/shapes";
		const body = JSON.stringify(shape);
		this._restClient.exec_post(url, body, callback);
	}

	update(shapeId, shape, callback) {
		const url = `/ecosystem/api/shapes/${shapeId}`;
		const body = JSON.stringify(shape);
		this._restClient.exec_put(url, body, callback);
	}

	delete(shapeId, callback) {
		const url = `/ecosystem/api/shapes/${shapeId}`;
		this._restClient.exec_delete(url, callback);
	}

	restore(entityId, callback) {
		const url = `/ecosystem/api/entities/${entityId}/restore`;
		this._restClient.exec_put(url, "{}", callback);
	}

	share(shapeId, callback) {
		const url = `/ecosystem/api/shapes/${shapeId}/share`;
		this._restClient.exec_put(url, "{}", callback);
	}

	unshareEntity(shapeId, callback) {
		const url = `/ecosystem/api/shapes/${shapeId}/unshare`;
		this._restClient.exec_put(url, "{}", callback);
	}

	getMyShapes(params = {}, callback) {
		const searchParams = new URLSearchParams();

		if (params.types && Array.isArray(params.types)) {
			searchParams.append("types", params.types.join(","));
		}

		if (params.includeHidden !== undefined) {
			searchParams.append("includeHidden", params.includeHidden);
		}

		const url = `/ecosystem/api/shapes?${searchParams.toString()}`;
		this._restClient.exec_get(url, callback);
	}

	getMultipleById(shapeIds, callback) {
		const joinedIds = shapeIds.join(",");
		const url = `/ecosystem/api/shapes/multiple/${joinedIds}`;
		this._restClient.exec_get(url, callback);
	}

	getByDisplayTargetId(displayTargetId, callback) {
		const url = `/ecosystem/api/shapes/getByDisplayTargetId/${displayTargetId}`;
		this._restClient.exec_get(url, callback);
	}
}
